import React from 'react';
import { ClassValue } from 'classnames/types';
import styles from './BodyText.module.scss';
import Typography, { TypographyProps, SupportedTagName } from '../Typography';
import { ArrayElementType } from '../../../types/utils/ArrayElementType';

type BodyTextProps<T extends SupportedTagName> = {
  size?: SupportedBodyTextSize;
  tagName?: keyof JSX.IntrinsicElements;
  htmlFor?: string;
} & Omit<TypographyProps<T>, 'font' | 'uppercase' | 'tagName'>;

function BodyText<T extends SupportedTagName>({
  tagName = 'p',
  className,
  size = 'md',
  htmlFor,
  children,
  ...props
}: BodyTextProps<T>) {
  const classNames: ClassValue = [
    styles[`bodyText__size_${size.toLowerCase()}`],
    className,
  ];

  return (
    <Typography
      tagName={tagName as SupportedTagName} // this circumvents some weird ts problem
      className={classNames}
      font="teliasans"
      uppercase={false}
      htmlFor={htmlFor}
      {...props}
    >
      {children}
    </Typography>
  );
}

export const supportedBodyTextSizes = ['md', 'sm', 'xs'] as const;

export type SupportedBodyTextSize = ArrayElementType<
  typeof supportedBodyTextSizes
>;

export default BodyText;
